import { requireRoute } from "@/auth/guard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/admins/audit")({
  beforeLoad: ({ context }) => requireRoute(context, "/admins/audit"),
});
